"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LOYALTY_TIERS = exports.ID_TYPE = exports.DEFAULT_STYLE = void 0;
const DEFAULT_STYLE = exports.DEFAULT_STYLE = {
  SUB: 'sub',
  LABEL_COLOR: 'neutral',
  VALUE_COLOR: 'greyDark',
  BACKGROUND: 'primary'
};
const ID_TYPE = exports.ID_TYPE = {
  BIG_MEMBER_ID: 'bigMemberId',
  BIG_MEMBER_POINTS: 'bigMemberPoints',
  STATUS: 'status',
  CREDIT: 'credit'
};
const LOYALTY_TIERS = exports.LOYALTY_TIERS = ['T1', 'T2', 'T3', 'T4'];